import React, { useState } from "react";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import moment from "moment";
const fmt = require("indian-number-format");
const backend = await new Backend().init();

export default function ListCard({ item, start, end, userType }) {
  const [loading, setLoading] = useState(false);

  const OpenEdit = () => {
    window.user_id = item.user_id;
    window.userModalOpen();
  };

  const createPdf = async () => {
    if (!start || !end) return toast.error("Select start and end date");

    setLoading(true);
    try {
      const r = await backend.createdpdf({ id: item.user_id, start, end });
      setTimeout(() => setLoading(false), 3000);

      if (r.error === "False") {
        setTimeout(() => window.open(r.url, "_blank"), 3000);
      } else toast.error(r.message);
    } catch {
      toast.error("Something went wrong");
      setLoading(false);
    }
  };

  return (
    <div
      className="w-full flex items-center justify-between bg-[var(--background)] border border-[var(--hover)] 
       transition-all duration-200 px-4 py-3 mb-2"
    >
      {/* User Info */}
      <div
        onClick={OpenEdit}
        className="flex flex-col cursor-pointer flex-[1.2] select-none"
      >
        {userType === 1 ? (
          <span className="text-[var(--text)] text-[12px] leading-tight">
            SUPER : ({item.super_username})
          </span>
        ) : null}
        {userType === 1 || userType === 2 ? (
          <span className="text-[var(--text)] text-[12px] leading-tight">
            MASTER : ({item.master_username})
          </span>
        ) : null}

        <span className="text-[var(--text)] font-medium text-[18px] hover:text-[var(--primary)] transition-all">
          {item.username}
        </span>
        <span className="text-[var(--text)] text-[12px] leading-tight">
          ({item.name})
        </span>
      </div>

      {/* Booked Amount */}
      <div
        className={`flex-[0.8] text-right font-semibold text-[15px] ${
          item.booked > 0 ? "text-[var(--buy)]" : "text-[var(--sell)]"
        }`}
      >
        ₹{fmt.format(item.booked)}
      </div>

      {/* Date */}
      <div className="flex-[1] text-center text-[var(--text)] text-[13px]">
        {moment(start).format("DD MMM")} → {moment(end).format("DD MMM")}
      </div>

      {/* Action */}
      <div className="flex justify-end flex-[1]">
        <button
          onClick={!loading ? createPdf : undefined}
          className={`px-4 py-1.5 text-[13px] font-semibold rounded-lg transition-all duration-200 
            ${
              loading
                ? "bg-[var(--hover)] text-[var(--text)] cursor-not-allowed"
                : "bg-[var(--primary)] hover:bg-[var(--primary)] text-white shadow-sm hover:shadow-blue-500/20"
            }`}
        >
          {loading ? "Generating..." : "Generate Bill"}
        </button>
      </div>
    </div>
  );
}
